import React from 'react';

const SaleSourcesContext = React.createContext(() => {
    throw new Error('Used SaleSourcesContext.Consumer without a Provider');
});
const { Provider, Consumer } = SaleSourcesContext;

export default SaleSourcesContext;
export { Provider, Consumer };
